import { render, staticRenderFns } from "./BarcodeOrderRereceiving.vue?vue&type=template&id=5c2f4c70"
import script from "./BarcodeOrderRereceiving.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderRereceiving.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports